import type { ForwardedRef, InputHTMLAttributes, ReactNode } from 'react'
import { forwardRef, useCallback, useRef } from 'react'
import style from './style.module.sass'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	suffix?: ReactNode
	suffixClassName?: string
}

export const Input = forwardRef(
	(
		{ className, suffix, suffixClassName, ...rest }: Props,
		ref: ForwardedRef<HTMLInputElement>
	) => {
		const inputRef = useRef<HTMLInputElement | null>(null)
		const setInputRef = useCallback(
			(node: HTMLInputElement | null) => {
				inputRef.current = node

				if (typeof ref === 'function') {
					ref(node)
					return
				}

				if (ref != null) {
					ref.current = node
				}
			},
			[ref]
		)

		if (suffix != null) {
			return (
				<span
					data-yakiniku="input"
					className={`control ${style.inputFrame} ${className || ''}`}
					onMouseDown={(event) => {
						if (
							event.target === inputRef.current ||
							rest.disabled
						) {
							return
						}

						event.preventDefault()
						inputRef.current?.focus()
					}}
				>
					<input
						{...rest}
						ref={setInputRef}
						className={style.inputElement}
					/>
					<span
						className={`${style.suffix} ${suffixClassName || ''}`}
					>
						{suffix}
					</span>
				</span>
			)
		}

		return (
			<input
				{...rest}
				ref={ref}
				data-yakiniku="input"
				className={`control ${style.input} ${className || ''}`}
			/>
		)
	}
)
